<template>
    <div>
        <div class="mb-3">
            <label class="form-label">Alto del espacio</label>
            <input class="form-control" type="text" :value="modelValue.height"
                @input="update('height', $event.target.value)" placeholder="24px">
        </div>
        <div class="mb-3">
            <label class="form-label">Color de fondo (opcional)</label>
            <div class="d-flex gap-2 align-items-center">
                <input class="form-control" type="text" :value="modelValue.backgroundColor"
                    @input="update('backgroundColor', $event.target.value)" placeholder="transparent">
                <input class="form-control form-control-color" type="color"
                    :value="modelValue.backgroundColor || '#ffffff'"
                    @input="update('backgroundColor', $event.target.value)">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MailingBlockSpacerEditor',
    props: {
        modelValue: { type: Object, default: () => ({}) },
    },
    emits: ['update:modelValue'],
    methods: {
        update(key, value) {
            this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
        },
    },
};
</script>
